import { PANEL_KOK } from "@/services/apiAdres";

// Paylaşılan public form bağlantıları (GomuluFormlar.vue FORM_TANIM ile aynı yol/kimlik, embed.js).
// BaglantiPaylas penceresi ve BSL-PENCERE «paylaş» adımı kullanır.
export const BAGLANTI_TIPLERI = {
  onkayit: {
    baslik: "Ön kayıt bağlantısı", yol: "/onkayit/onkayitform", kimlik: "SubeGuid",
    metin: "Bu bağlantıyı WhatsApp'tan, sitenizden ya da QR koduyla paylaşın. Doldurulan başvurular Ön Kayıt listesine düşer.",
    mesaj: "Ön kayıt için formu doldurabilirsiniz:",
  },
  randevu: {
    baslik: "Randevu bağlantısı", yol: "/randevusistemi/randevual", kimlik: "SubeGuid",
    metin: "Bu bağlantıyı WhatsApp'tan, sitenizden ya da QR koduyla paylaşın. Müşteriniz boş saati seçip randevu alır.",
    mesaj: "Online randevu almak için:",
  },
  talep: {
    baslik: "Teklif talep bağlantısı", yol: "/teklif/talepolustur", kimlik: "SubeGuid",
    metin: "Bu bağlantıyı WhatsApp'tan, sitenizden ya da QR koduyla paylaşın. Gelen talepler Teklif listesine düşer.",
    mesaj: "Teklif istemek için:",
  },
  cagri: {
    baslik: "Destek çağrısı bağlantısı", yol: "/cagrisistemi/cagriolustur", kimlik: "SirketGuid",
    metin: "Bu bağlantıyı sitenize ya da müşterilerinize verin. Formu yalnız e-postası kayıtlı müşterileriniz kullanabilir; açılan çağrılar Çağrı Listesi'ne düşer.", // BSL-DST Y5
    mesaj: "Destek talebi için:",
  },
};

// GetSirketBaglantiInfo cevabından [{ kimlik, ad, url }] (şube başına ya da şirket için tek).
export function baglantiListesi(tip, subeler, sirketGuid) {
  const t = BAGLANTI_TIPLERI[tip] || BAGLANTI_TIPLERI.onkayit;
  if (t.kimlik === "SirketGuid") {
    return sirketGuid ? [{ kimlik: sirketGuid, ad: "", url: `${PANEL_KOK}${t.yol}?SirketGuid=${sirketGuid}` }] : [];
  }
  return (subeler || []).map((s) => ({ kimlik: s.SubeGuid, ad: s.SubeAd, url: `${PANEL_KOK}${t.yol}?SubeGuid=${s.SubeGuid}` }));
}
